module.exports = __webpack_public_path__ + "static/media/bg-default-news.75d1e055.png";